/*
 * Copyright Red Hat, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const CustomCursor = (props: any) => {
  const { points, cursorHeight = 250 } = props;
  if (!points || points.length === 0) return null;

  return (
    <line
      data-testid="custom-cursor-line"
      x1={points[0].x}
      y1={10}
      x2={points[0].x}
      y2={cursorHeight}
      stroke="gray"
      strokeWidth={1}
      strokeDasharray="3 3"
    />
  );
};

export default CustomCursor;
